import layoutHeaderAside from '@/layouts/HeaderAside'

const meta = {auth: true}
export default {
  path: '/myMessage',
  meta,
  component: layoutHeaderAside,
  children: [
    {
      path: '/myMessage',
      name: 'myMessage',
      component: () => import('@/pages/myMessage/index.vue'),
      meta: {
        ...meta,
        title: '',
        requireAuth: true
      },
    }
  ]
}
